module.exports = __webpack_public_path__ + "img/recmd_top_header.31de79bb.png";